import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Tab, Nav, Badge, Dropdown } from 'react-bootstrap';
import './AgencyMyaccount.css';
import Swal from 'sweetalert2';
import AgencyNavbar from '../../Pages/Navbar/AgencyNavbar';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import BaseUrl from '../../ApiServices/BaseUrl';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    FaBuilding, FaMapMarkerAlt, FaWhatsapp, FaUser,
    FaLock, FaShieldAlt, FaSave, FaArrowLeft, FaPhone, FaEnvelope,
    FaGlobe, FaInfoCircle, FaTags, FaEdit, FaExclamationCircle,
    FaFileAlt, FaIdCard, FaImage, FaCheckCircle, FaCrown, FaSearch
} from 'react-icons/fa';
import { BsEye, BsEyeSlash } from 'react-icons/bs';

// ─── Country codes list ─────────────────────────────────────────────────────
const COUNTRY_CODES = [
    { code: '+93', label: 'Afghanistan (+93)' },
    { code: '+355', label: 'Albania (+355)' },
    { code: '+213', label: 'Algeria (+213)' },
    { code: '+376', label: 'Andorra (+376)' },
    { code: '+244', label: 'Angola (+244)' },
    { code: '+54', label: 'Argentina (+54)' },
    { code: '+374', label: 'Armenia (+374)' },
    { code: '+61', label: 'Australia (+61)' },
    { code: '+43', label: 'Austria (+43)' },
    { code: '+994', label: 'Azerbaijan (+994)' },
    { code: '+973', label: 'Bahrain (+973)' },
    { code: '+880', label: 'Bangladesh (+880)' },
    { code: '+375', label: 'Belarus (+375)' },
    { code: '+32', label: 'Belgium (+32)' },
    { code: '+501', label: 'Belize (+501)' },
    { code: '+229', label: 'Benin (+229)' },
    { code: '+975', label: 'Bhutan (+975)' },
    { code: '+591', label: 'Bolivia (+591)' },
    { code: '+387', label: 'Bosnia (+387)' },
    { code: '+267', label: 'Botswana (+267)' },
    { code: '+55', label: 'Brazil (+55)' },
    { code: '+673', label: 'Brunei (+673)' },
    { code: '+359', label: 'Bulgaria (+359)' },
    { code: '+226', label: 'Burkina Faso (+226)' },
    { code: '+257', label: 'Burundi (+257)' },
    { code: '+855', label: 'Cambodia (+855)' },
    { code: '+237', label: 'Cameroon (+237)' },
    { code: '+1', label: 'Canada (+1)' },
    { code: '+236', label: 'Central African Republic (+236)' },
    { code: '+235', label: 'Chad (+235)' },
    { code: '+56', label: 'Chile (+56)' },
    { code: '+86', label: 'China (+86)' },
    { code: '+57', label: 'Colombia (+57)' },
    { code: '+506', label: 'Costa Rica (+506)' },
    { code: '+385', label: 'Croatia (+385)' },
    { code: '+53', label: 'Cuba (+53)' },
    { code: '+357', label: 'Cyprus (+357)' },
    { code: '+420', label: 'Czech Republic (+420)' },
    { code: '+45', label: 'Denmark (+45)' },
    { code: '+253', label: 'Djibouti (+253)' },
    { code: '+593', label: 'Ecuador (+593)' },
    { code: '+20', label: 'Egypt (+20)' },
    { code: '+503', label: 'El Salvador (+503)' },
    { code: '+372', label: 'Estonia (+372)' },
    { code: '+251', label: 'Ethiopia (+251)' },
    { code: '+679', label: 'Fiji (+679)' },
    { code: '+358', label: 'Finland (+358)' },
    { code: '+33', label: 'France (+33)' },
    { code: '+241', label: 'Gabon (+241)' },
    { code: '+220', label: 'Gambia (+220)' },
    { code: '+995', label: 'Georgia (+995)' },
    { code: '+49', label: 'Germany (+49)' },
    { code: '+233', label: 'Ghana (+233)' },
    { code: '+30', label: 'Greece (+30)' },
    { code: '+502', label: 'Guatemala (+502)' },
    { code: '+224', label: 'Guinea (+224)' },
    { code: '+509', label: 'Haiti (+509)' },
    { code: '+504', label: 'Honduras (+504)' },
    { code: '+852', label: 'Hong Kong (+852)' },
    { code: '+36', label: 'Hungary (+36)' },
    { code: '+354', label: 'Iceland (+354)' },
    { code: '+91', label: 'India (+91)' },
    { code: '+62', label: 'Indonesia (+62)' },
    { code: '+98', label: 'Iran (+98)' },
    { code: '+964', label: 'Iraq (+964)' },
    { code: '+353', label: 'Ireland (+353)' },
    { code: '+972', label: 'Israel (+972)' },
    { code: '+39', label: 'Italy (+39)' },
    { code: '+81', label: 'Japan (+81)' },
    { code: '+962', label: 'Jordan (+962)' },
    { code: '+7', label: 'Kazakhstan (+7)' },
    { code: '+254', label: 'Kenya (+254)' },
    { code: '+82', label: 'South Korea (+82)' },
    { code: '+965', label: 'Kuwait (+965)' },
    { code: '+996', label: 'Kyrgyzstan (+996)' },
    { code: '+856', label: 'Laos (+856)' },
    { code: '+371', label: 'Latvia (+371)' },
    { code: '+961', label: 'Lebanon (+961)' },
    { code: '+266', label: 'Lesotho (+266)' },
    { code: '+231', label: 'Liberia (+231)' },
    { code: '+218', label: 'Libya (+218)' },
    { code: '+370', label: 'Lithuania (+370)' },
    { code: '+352', label: 'Luxembourg (+352)' },
    { code: '+853', label: 'Macau (+853)' },
    { code: '+261', label: 'Madagascar (+261)' },
    { code: '+265', label: 'Malawi (+265)' },
    { code: '+60', label: 'Malaysia (+60)' },
    { code: '+960', label: 'Maldives (+960)' },
    { code: '+223', label: 'Mali (+223)' },
    { code: '+356', label: 'Malta (+356)' },
    { code: '+52', label: 'Mexico (+52)' },
    { code: '+373', label: 'Moldova (+373)' },
    { code: '+377', label: 'Monaco (+377)' },
    { code: '+976', label: 'Mongolia (+976)' },
    { code: '+382', label: 'Montenegro (+382)' },
    { code: '+212', label: 'Morocco (+212)' },
    { code: '+258', label: 'Mozambique (+258)' },
    { code: '+95', label: 'Myanmar (+95)' },
    { code: '+264', label: 'Namibia (+264)' },
    { code: '+977', label: 'Nepal (+977)' },
    { code: '+31', label: 'Netherlands (+31)' },
    { code: '+64', label: 'New Zealand (+64)' },
    { code: '+505', label: 'Nicaragua (+505)' },
    { code: '+227', label: 'Niger (+227)' },
    { code: '+234', label: 'Nigeria (+234)' },
    { code: '+47', label: 'Norway (+47)' },
    { code: '+968', label: 'Oman (+968)' },
    { code: '+92', label: 'Pakistan (+92)' },
    { code: '+970', label: 'Palestine (+970)' },
    { code: '+507', label: 'Panama (+507)' },
    { code: '+595', label: 'Paraguay (+595)' },
    { code: '+51', label: 'Peru (+51)' },
    { code: '+63', label: 'Philippines (+63)' },
    { code: '+48', label: 'Poland (+48)' },
    { code: '+351', label: 'Portugal (+351)' },
    { code: '+974', label: 'Qatar (+974)' },
    { code: '+40', label: 'Romania (+40)' },
    { code: '+7', label: 'Russia (+7)' },
    { code: '+250', label: 'Rwanda (+250)' },
    { code: '+966', label: 'Saudi Arabia (+966)' },
    { code: '+221', label: 'Senegal (+221)' },
    { code: '+381', label: 'Serbia (+381)' },
    { code: '+65', label: 'Singapore (+65)' },
    { code: '+421', label: 'Slovakia (+421)' },
    { code: '+386', label: 'Slovenia (+386)' },
    { code: '+252', label: 'Somalia (+252)' },
    { code: '+27', label: 'South Africa (+27)' },
    { code: '+211', label: 'South Sudan (+211)' },
    { code: '+34', label: 'Spain (+34)' },
    { code: '+94', label: 'Sri Lanka (+94)' },
    { code: '+249', label: 'Sudan (+249)' },
    { code: '+46', label: 'Sweden (+46)' },
    { code: '+41', label: 'Switzerland (+41)' },
    { code: '+963', label: 'Syria (+963)' },
    { code: '+886', label: 'Taiwan (+886)' },
    { code: '+992', label: 'Tajikistan (+992)' },
    { code: '+255', label: 'Tanzania (+255)' },
    { code: '+66', label: 'Thailand (+66)' },
    { code: '+228', label: 'Togo (+228)' },
    { code: '+216', label: 'Tunisia (+216)' },
    { code: '+90', label: 'Turkey (+90)' },
    { code: '+993', label: 'Turkmenistan (+993)' },
    { code: '+256', label: 'Uganda (+256)' },
    { code: '+380', label: 'Ukraine (+380)' },
    { code: '+971', label: 'UAE (+971)' },
    { code: '+44', label: 'UK (+44)' },
    { code: '+1', label: 'USA (+1)' },
    { code: '+598', label: 'Uruguay (+598)' },
    { code: '+998', label: 'Uzbekistan (+998)' },
    { code: '+58', label: 'Venezuela (+58)' },
    { code: '+84', label: 'Vietnam (+84)' },
    { code: '+967', label: 'Yemen (+967)' },
    { code: '+260', label: 'Zambia (+260)' },
    { code: '+263', label: 'Zimbabwe (+263)' },
];

// ─── Searchable Country Code Dropdown ───────────────────────────────────────
function SearchableCountryCode({ name, value, onChange, disabled }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [show, setShow] = useState(false);

    const filtered = COUNTRY_CODES.filter(c =>
        c.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.code.includes(searchTerm)
    );

    const selectedCountry = COUNTRY_CODES.find(c => c.code === value);

    const handleSelect = (code) => {
        onChange({ target: { name, value: code } });
        setShow(false);
        setSearchTerm('');
    };

    return (
        <Dropdown className="flex-shrink-0" show={show} onToggle={setShow}>
            <Dropdown.Toggle
                variant="outline-secondary"
                id={`dropdown-${name}`}
                className={`country-code-toggle ${disabled ? 'disabled' : ''}`}
                disabled={disabled}
                style={{
                    width: '90px', height: '46px', fontSize: '14px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    backgroundColor: disabled ? '#f9fafb' : '#fff',
                    borderColor: '#d1d5db',
                    color: disabled ? '#6b7280' : '#1a1a1a',
                    borderRadius: '7px 0 0 7px'
                }}
            >
                {selectedCountry ? selectedCountry.code : (value || '+')}
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="country-dropdown-menu"
                style={{
                    width: '280px', maxHeight: '350px',
                    overflow: 'hidden', display: 'flex', flexDirection: 'column',
                    padding: 0, border: '1px solid #ced4da', boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
            >
                <div className="p-2 border-bottom bg-light" onClick={(e) => e.stopPropagation()}>
                    <div className="position-relative">
                        <FaSearch
                            className="position-absolute"
                            style={{ top: '10px', left: '12px', color: '#9ca3af', fontSize: '12px' }}
                        />
                        <Form.Control
                            autoFocus
                            placeholder="Search country/code..."
                            size="sm"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            style={{ paddingLeft: '32px', fontSize: '13px', height: '34px' }}
                        />
                    </div>
                </div>
                <div style={{ overflowY: 'auto', maxHeight: '250px' }}>
                    {filtered.length > 0 ? (
                        filtered.map(c => (
                            <Dropdown.Item
                                key={`${c.code}-${c.label}`}
                                active={c.code === value}
                                onClick={() => handleSelect(c.code)}
                                style={{
                                    fontSize: '14px', padding: '8px 16px',
                                    display: 'flex', justifyContent: 'space-between'
                                }}
                            >
                                <span>{c.label.split(' (')[0]}</span>
                                <span className="text-muted">{c.code}</span>
                            </Dropdown.Item>
                        ))
                    ) : (
                        <div className="px-3 py-3 text-muted small text-center">No results found</div>
                    )}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

const RECRUITMENT_CATEGORIES = [
    'Domestic Helper / Housemaid',
    'Driver',
    'Cook / Chef',
    'Nurse / Healthcare',
    'Construction / Labor',
    'IT / Technology',
    'Hospitality / Hotel Staff',
    'Security Guard',
    'Sales & Marketing',
    'Office / Administrative',
    'Agriculture / Farm Worker',
    'Delivery / Logistics',
    'Other',
];

// Fields the agency can self-edit
const AGENCY_EDITABLE_FIELDS = [
    'email',
    'official_phone',
    'official_phone_country_code',
    'website_url',
    'youtube_link',
    'youtube_link_2',
    'whatsapp_number_1',
    'whatsapp_number_1_country_code',
    'whatsapp_number_2',
    'whatsapp_number_2_country_code',
    'whatsapp_number_3',
    'whatsapp_number_3_country_code',
    'whatsapp_number_4',
    'whatsapp_number_4_country_code'
];

// ─── PhoneField component ───────────────────────────────────────────────────
function PhoneField({ label, codeName, numberName, codeValue, numberValue, onChange, editable, required = false }) {
    return (
        <Form.Group className="agency-account-form-group">
            <Form.Label className="agency-account-label">
                {label} {required && <span className="text-danger">*</span>}
                {!editable && (
                    <FaLock title="Contact admin to update" style={{ marginLeft: 6, fontSize: 11, color: '#aaa', verticalAlign: 'middle' }} />
                )}
            </Form.Label>
            <div className="d-flex align-items-stretch">
                <SearchableCountryCode
                    name={codeName}
                    value={codeValue}
                    onChange={onChange}
                    disabled={!editable}
                />
                <Form.Control
                    type="tel"
                    name={numberName}
                    value={numberValue}
                    onChange={onChange}
                    readOnly={!editable}
                    disabled={!editable}
                    className={`agency-account-input ${!editable ? 'agency-field-locked' : ''}`}
                    placeholder="Phone number"
                    style={{
                        borderRadius: '0 7px 7px 0',
                        borderLeft: 'none',
                        ...(!editable ? { backgroundColor: '#f5f5f5', color: '#6c757d', cursor: 'not-allowed' } : {})
                    }}
                />
            </div>
            {!editable && (
                <small className="text-muted" style={{ fontSize: 11 }}><FaLock size={10} className="me-1" />Contact admin to update</small>
            )}
        </Form.Group>
    );
}

// ─── Simple Text Field Component ──────────────────────────────────────────
const Field = ({ label, name, type = 'text', as, rows, placeholder, required = false, formData, handleChange, isFieldEditable }) => {
    const editable = isFieldEditable(name);
    return (
        <Form.Group className="agency-account-form-group">
            <Form.Label className="agency-account-label">
                {label} {required && <span className="text-danger">*</span>}
                {!editable && <FaLock title="Contact admin to update" style={{ marginLeft: 6, fontSize: 11, color: '#aaa', verticalAlign: 'middle' }} />}
            </Form.Label>
            <Form.Control
                as={as} rows={rows}
                type={as ? undefined : type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                readOnly={!editable}
                disabled={!editable}
                placeholder={placeholder || label}
                className={`agency-account-input ${!editable ? 'agency-field-locked' : ''}`}
                style={!editable ? { backgroundColor: '#f5f5f5', color: '#6c757d', cursor: 'not-allowed' } : {}}
            />
            {!editable && <small className="text-muted" style={{ fontSize: 11 }}><FaLock size={10} className="me-1" />Contact admin to update</small>}
        </Form.Group>
    );
};

// ─── Main Component ─────────────────────────────────────────────────────────
function AgencyMyaccount() {
    const emptyForm = {
        agency_name: '',
        contact_person_name: '',
        about_agency: '',
        recruitment_categories: [],
        city: '',
        province: '',
        country: '',
        full_address: '',
        official_phone: '',
        official_phone_country_code: '+971',
        email: '',
        website_url: '',
        youtube_link: '',
        youtube_link_2: '',
        whatsapp_number_1: '', whatsapp_number_1_country_code: '+971',
        whatsapp_number_2: '', whatsapp_number_2_country_code: '',
        whatsapp_number_3: '', whatsapp_number_3_country_code: '',
        whatsapp_number_4: '', whatsapp_number_4_country_code: '',
        owner_name: '',
        owner_nationality: '',
        owner_mobile: '', owner_mobile_country_code: '+971',
        owner_email: '',
        manager_name: '',
        manager_nationality: '',
        manager_mobile: '', manager_mobile_country_code: '+971',
        manager_email: '',
        password: '',
        is_verified: 0,
        selected_plan: 'Free',
        company_logo: null,
        business_card: null,
        license_copy: null,
        owner_photo: null,
        office_building_photo: null,
    };

    const [formData, setFormData] = useState(emptyForm);
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false);
    const [userId, setUserId] = useState(null);
    const [agencyName, setAgencyName] = useState('');

    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const adminEditId = searchParams.get('adminEditId');
    const isAdminMode = !!adminEditId;

    const isFieldEditable = (fieldName) => {
        if (isAdminMode) return true;
        return AGENCY_EDITABLE_FIELDS.includes(fieldName);
    };

    useEffect(() => {
        if (isAdminMode) {
            setUserId(adminEditId);
            fetchAgencyData(adminEditId);
        } else {
            const user = JSON.parse(localStorage.getItem('user'));
            if (user && user.id) {
                setUserId(user.id);
                fetchAgencyData(user.id);
            } else {
                Swal.fire({ title: 'Error!', text: 'Please login again.', icon: 'error' }).then(() => {
                    window.location.href = '/login';
                });
            }
        }
    }, [adminEditId]);

    const fetchAgencyData = async (id) => {
        try {
            const res = await fetch(`${BaseUrl}/api/agency/${id}`);
            if (!res.ok) throw new Error('Failed to fetch');
            const d = await res.json();
            setAgencyName(d.agency_name || '');

            // Parse recruitment_categories (stored as JSON string or array)
            let cats = [];
            try {
                cats = typeof d.recruitment_categories === 'string'
                    ? JSON.parse(d.recruitment_categories)
                    : (d.recruitment_categories || []);
                if (!Array.isArray(cats)) cats = [];
            } catch { cats = []; }

            setFormData({
                agency_name: d.agency_name || '',
                contact_person_name: d.contact_person_name || '',
                about_agency: d.about_agency || '',
                recruitment_categories: cats,
                city: d.city || '',
                province: d.province || '',
                country: d.country || '',
                full_address: d.full_address || '',
                official_phone: d.official_phone || '',
                official_phone_country_code: d.official_phone_country_code || '+971',
                email: d.email || '',
                website_url: d.website_url || '',
                youtube_link: d.youtube_link || '',
                youtube_link_2: d.youtube_link_2 || '',
                whatsapp_number_1: d.whatsapp_number_1 || '',
                whatsapp_number_1_country_code: d.whatsapp_number_1_country_code || '+971',
                whatsapp_number_2: d.whatsapp_number_2 || '',
                whatsapp_number_2_country_code: d.whatsapp_number_2_country_code || '',
                whatsapp_number_3: d.whatsapp_number_3 || '',
                whatsapp_number_3_country_code: d.whatsapp_number_3_country_code || '',
                whatsapp_number_4: d.whatsapp_number_4 || '',
                whatsapp_number_4_country_code: d.whatsapp_number_4_country_code || '',
                owner_name: d.owner_name || d.contact_person_name || '',
                owner_nationality: d.owner_nationality || '',
                owner_mobile: d.owner_mobile || '',
                owner_mobile_country_code: d.owner_mobile_country_code || '+971',
                owner_email: d.owner_email || '',
                manager_name: d.manager_name || '',
                manager_nationality: d.manager_nationality || '',
                manager_mobile: d.manager_mobile || '',
                manager_mobile_country_code: d.manager_mobile_country_code || '+971',
                manager_email: d.manager_email || '',
                password: '',
                is_verified: d.is_verified || 0,
                selected_plan: d.selected_plan || 'Free',
                company_logo: d.company_logo,
                business_card: d.business_card,
                license_copy: d.license_copy,
                owner_photo: d.owner_photo,
                office_building_photo: d.office_building_photo,
            });
            setLoading(false);
        } catch (err) {
            Swal.fire({ title: 'Error!', text: 'Failed to load agency data', icon: 'error' });
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (!isAdminMode && !AGENCY_EDITABLE_FIELDS.includes(name) && name !== 'password') return;
        if (type === 'checkbox') {
            // recruitment categories
            const cats = formData.recruitment_categories || [];
            setFormData({
                ...formData,
                recruitment_categories: checked
                    ? [...cats, value]
                    : cats.filter(c => c !== value)
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleUpdate = async () => {
        setIsUpdating(true);
        try {
            const formDataToSubmit = new FormData();

            // Append all text fields
            Object.keys(formData).forEach(key => {
                if (key === 'recruitment_categories') {
                    formDataToSubmit.append(key, JSON.stringify(formData[key]));
                } else if (key === 'password') {
                    if (formData[key]) formDataToSubmit.append(key, formData[key]);
                } else if ([
                    'company_logo', 'business_card', 'license_copy',
                    'owner_photo', 'office_building_photo'
                ].includes(key)) {
                    // Files are handled below if they are new File objects
                } else {
                    formDataToSubmit.append(key, formData[key]);
                }
            });

            // Append new files if any
            if (formData.company_logo instanceof File) formDataToSubmit.append('company_logo', formData.company_logo);
            if (formData.business_card instanceof File) formDataToSubmit.append('business_card', formData.business_card);
            if (formData.license_copy instanceof File) formDataToSubmit.append('license_copy', formData.license_copy);
            if (formData.owner_photo instanceof File) formDataToSubmit.append('owner_photo', formData.owner_photo);
            if (formData.office_building_photo instanceof File) formDataToSubmit.append('office_building_photo', formData.office_building_photo);

            const res = await fetch(`${BaseUrl}/api/agency/${userId}`, {
                method: 'PUT',
                body: formDataToSubmit,
                // Do not set Content-Type header when using FormData; the browser will set it with the boundary
            });

            if (!res.ok) throw new Error('Update failed');

            Swal.fire({ title: 'Success!', text: 'Agency profile updated successfully!', icon: 'success', confirmButtonColor: '#28a745' })
                .then(() => {
                    if (isAdminMode) navigate('/manageallagency');
                    else fetchAgencyData(userId); // Refresh data to show new images
                });
        } catch (err) {
            console.error('Update error:', err);
            Swal.fire({ title: 'Error!', text: 'Failed to update agency profile', icon: 'error' });
        } finally {
            setIsUpdating(false);
        }
    };

    const NavbarToRender = isAdminMode ? AdminNavbar : AgencyNavbar;

    if (loading) return (
        <>
            <NavbarToRender />
            <Container className="py-4 text-center" style={{ marginTop: 80 }}>
                <div className="spinner-border text-success" role="status" style={{ width: 40, height: 40 }} />
                <p className="mt-3 text-muted">Loading agency profile...</p>
            </Container>
        </>
    );

    return (
        <>
            <NavbarToRender />

            {/* ── Admin Mode Banner ── */}
            {isAdminMode && (
                <div style={{
                    background: 'linear-gradient(135deg,#1a237e,#283593)', color: '#fff',
                    padding: '10px 24px', marginTop: 65,
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8
                }}>
                    <div>
                        <FaShieldAlt style={{ marginRight: 8 }} /><strong>Admin Edit Mode</strong>
                        <span style={{ marginLeft: 10, fontSize: 13, opacity: 0.9 }}>
                            Editing: <strong>{agencyName}</strong> (ID: {adminEditId}) — All fields editable
                        </span>
                    </div>
                    <button onClick={() => navigate('/manageallagency')} style={{
                        background: 'rgba(255,255,255,0.2)', color: '#fff',
                        border: '1px solid rgba(255,255,255,0.4)', borderRadius: 6,
                        padding: '4px 14px', cursor: 'pointer', fontSize: 13
                    }}>
                        <FaArrowLeft style={{ marginRight: 6 }} />Back to Manage Agencies
                    </button>
                </div>
            )}

            {/* ── Agency Info Banner ── */}
            {!isAdminMode && (
                <div style={{
                    background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 8,
                    padding: '10px 18px', margin: '80px 20px 0',
                    display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#7a5e00'
                }}>
                    <FaInfoCircle style={{ fontSize: 20, flexShrink: 0 }} />
                    <span>
                        You can self-update your <strong>Official Email</strong>, <strong>Official Phone</strong>, and <strong>Website URL</strong>.
                        All other fields require admin approval — please <strong>contact the admin</strong> to update them. <FaLock size={10} />
                    </span>
                </div>
            )}

            <Container className="agencyaccount-container" style={{ marginTop: isAdminMode ? 16 : 20, paddingBottom: 60 }}>
                <Tab.Container defaultActiveKey="profile">
                    <Nav variant="tabs" className="mb-0 justify-content-start">
                        <Nav.Item>
                            <Nav.Link eventKey="profile" className="agency-account-profile-tab" style={{ fontWeight: 600, fontSize: 15 }}>
                                {isAdminMode
                                    ? <><FaEdit style={{ marginRight: 6 }} />Edit Agency Profile</>
                                    : <><FaUser style={{ marginRight: 6 }} />My Agency Profile</>}
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <div style={{ background: '#fff', borderRadius: '0 8px 8px 8px', border: '1px solid #dee2e6', padding: '28px 24px' }}>
                        <Tab.Content>
                            <Tab.Pane eventKey="profile">

                                {/* ══════════ SECTION 1: Agency Information ══════════ */}
                                <SectionCard title="Agency Information" icon={<FaBuilding />} color="#1565C0">
                                    <Row className="g-3">
                                        <Col xs={12} lg={6}><Field label="Agency Name" name="agency_name" required formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col xs={12} lg={6}><Field label="Owner Name" name="contact_person_name" formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={12}><Field label="About Agency" name="about_agency" as="textarea" rows={3} placeholder="Brief description of your agency..." formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={12}>
                                            <Form.Group className="agency-account-form-group">
                                                <Form.Label className="agency-account-label">
                                                    Recruitment Categories
                                                    {!isAdminMode && <FaLock title="Contact admin to update" style={{ marginLeft: 6, fontSize: 11, color: '#aaa', verticalAlign: 'middle' }} />}
                                                </Form.Label>

                                                {/* Clean 3-column grid — no scroll, no minWidth hack */}
                                                <div className="recruitment-grid" style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                                    gap: '10px 20px',
                                                    border: '1.5px solid #d1d5db',
                                                    borderRadius: 8,
                                                    padding: '16px 18px',
                                                    background: !isAdminMode ? '#f9fafb' : '#fff'
                                                }}>
                                                    {RECRUITMENT_CATEGORIES.map(cat => (
                                                        <div key={cat} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <input
                                                                type="checkbox"
                                                                id={`cat-${cat}`}
                                                                name="recruitment_categories"
                                                                value={cat}
                                                                checked={(formData.recruitment_categories || []).includes(cat)}
                                                                onChange={handleChange}
                                                                disabled={!isAdminMode}
                                                                style={{
                                                                    width: 16, height: 16, flexShrink: 0,
                                                                    accentColor: '#2E7D32',
                                                                    cursor: isAdminMode ? 'pointer' : 'not-allowed'
                                                                }}
                                                            />
                                                            <label
                                                                htmlFor={`cat-${cat}`}
                                                                style={{
                                                                    fontSize: 14,
                                                                    color: !isAdminMode ? '#6b7280' : '#212529',
                                                                    cursor: isAdminMode ? 'pointer' : 'not-allowed',
                                                                    margin: 0, lineHeight: 1.4
                                                                }}
                                                            >
                                                                {cat}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>

                                                {/* Selected badge summary */}
                                                {(formData.recruitment_categories || []).length > 0 && (
                                                    <div className="d-flex flex-wrap gap-1 mt-2">
                                                        {(formData.recruitment_categories || []).map(c => (
                                                            <Badge key={c} bg="success" style={{ fontSize: 12 }}>{c}</Badge>
                                                        ))}
                                                    </div>
                                                )}

                                                {!isAdminMode && (
                                                    <small className="text-muted" style={{ fontSize: 12 }}>
                                                        <FaLock size={10} className="me-1" />Contact admin to update
                                                    </small>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </SectionCard>

                                {/* ══════════ SECTION 2: Contact & Location ══════════ */}
                                <SectionCard title="Contact & Location" icon={<FaMapMarkerAlt />} color="#2E7D32">
                                    <Row className="g-4">
                                        <Col md={4}><Field label="City" name="city" formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={4}><Field label="Province / State" name="province" formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={4}><Field label="Country" name="country" formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={12}><Field label="Full Address" name="full_address" as="textarea" rows={2} formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={6}>
                                            <PhoneField
                                                label="Official Phone"
                                                codeName="official_phone_country_code"
                                                numberName="official_phone"
                                                codeValue={formData.official_phone_country_code}
                                                numberValue={formData.official_phone}
                                                onChange={handleChange}
                                                editable={isFieldEditable('official_phone')}
                                                required
                                            />
                                        </Col>
                                        <Col md={6}><Field label="Official Email" name="email" type="email" required formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={12}><Field label="Website URL" name="website_url" type="url" placeholder="https://yourwebsite.com" formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={12}><Field label="Add YouTube intro video for faster selection (1)" name="youtube_link" type="url" placeholder="https://www.youtube.com/watch?v=..." formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col md={12}><Field label="Add YouTube intro video for faster selection (2)" name="youtube_link_2" type="url" placeholder="https://www.youtube.com/watch?v=..." formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                    </Row>
                                </SectionCard>

                                {/* ══════════ SECTION 2.5: Account Status ══════════ */}
                                <SectionCard title="Account Status" icon={<FaShieldAlt />} color="#0277BD">
                                    <Row className="g-4">
                                        <Col md={6}>
                                            <Form.Group className="agency-account-form-group">
                                                <Form.Label className="agency-account-label">Verification Status</Form.Label>
                                                <div className="d-flex align-items-center gap-3 py-2">
                                                    {formData.is_verified ? (
                                                        <Badge bg="success" style={{ padding: '8px 16px', fontSize: '14px' }}>
                                                            <FaCheckCircle className="me-2" /> Verified Agency
                                                        </Badge>
                                                    ) : (
                                                        <Badge bg="warning" text="dark" style={{ padding: '8px 16px', fontSize: '14px' }}>
                                                            <FaExclamationCircle className="me-2" /> Pending Verification
                                                        </Badge>
                                                    )}
                                                    {isAdminMode && (
                                                        <Form.Check
                                                            type="switch"
                                                            id="is_verified_switch"
                                                            label="Verified"
                                                            checked={formData.is_verified === 1 || formData.is_verified === true}
                                                            onChange={(e) => setFormData({ ...formData, is_verified: e.target.checked ? 1 : 0 })}
                                                            className="ms-3"
                                                        />
                                                    )}
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="agency-account-form-group">
                                                <Form.Label className="agency-account-label">Subscription Plan</Form.Label>
                                                <div className="d-flex align-items-center gap-3 py-2">
                                                    <Badge bg="info" style={{ padding: '8px 16px', fontSize: '14px', background: 'linear-gradient(45deg, #0288D1, #26C6DA)' }}>
                                                        <FaCrown className="me-2" /> {formData.selected_plan || 'Free'} Plan
                                                    </Badge>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </SectionCard>

                                {/* ══════════ SECTION 3: WhatsApp Numbers ══════════ */}
                                <SectionCard title="WhatsApp Numbers" icon={<FaWhatsapp />} color="#25D366">
                                    <Row className="g-3">
                                        <Col xs={12} lg={6}>
                                            <PhoneField label="WhatsApp #1 (Primary)" codeName="whatsapp_number_1_country_code" numberName="whatsapp_number_1"
                                                codeValue={formData.whatsapp_number_1_country_code} numberValue={formData.whatsapp_number_1}
                                                onChange={handleChange} editable={isFieldEditable('whatsapp_number_1')} required />
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <PhoneField label="WhatsApp #2" codeName="whatsapp_number_2_country_code" numberName="whatsapp_number_2"
                                                codeValue={formData.whatsapp_number_2_country_code} numberValue={formData.whatsapp_number_2}
                                                onChange={handleChange} editable={isFieldEditable('whatsapp_number_2')} />
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <PhoneField label="WhatsApp #3" codeName="whatsapp_number_3_country_code" numberName="whatsapp_number_3"
                                                codeValue={formData.whatsapp_number_3_country_code} numberValue={formData.whatsapp_number_3}
                                                onChange={handleChange} editable={isFieldEditable('whatsapp_number_3')} />
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <PhoneField label="WhatsApp #4" codeName="whatsapp_number_4_country_code" numberName="whatsapp_number_4"
                                                codeValue={formData.whatsapp_number_4_country_code} numberValue={formData.whatsapp_number_4}
                                                onChange={handleChange} editable={isFieldEditable('whatsapp_number_4')} />
                                        </Col>
                                    </Row>
                                </SectionCard>

                                {/* ══════════ SECTION 4: Owner Information ══════════ */}
                                <SectionCard title="Owner / Director Information" icon={<FaUser />} color="#4527A0">
                                    <Row className="g-3">
                                        <Col xs={12} lg={6}><Field label="Owner Name" name="owner_name" formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col xs={12} lg={6}><Field label="Owner Nationality" name="owner_nationality" formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                        <Col xs={12} lg={6}>
                                            <PhoneField label="Owner Mobile" codeName="owner_mobile_country_code" numberName="owner_mobile"
                                                codeValue={formData.owner_mobile_country_code} numberValue={formData.owner_mobile}
                                                onChange={handleChange} editable={isFieldEditable('owner_mobile')} />
                                        </Col>
                                        <Col xs={12} lg={6}><Field label="Owner Email" name="owner_email" type="email" formData={formData} handleChange={handleChange} isFieldEditable={isFieldEditable} /></Col>
                                    </Row>
                                </SectionCard>

                                {/* ══════════ SECTION 5.5: Agency Documents ══════════ */}
                                <SectionCard title="Agency Documents" icon={<FaFileAlt />} color="#455A64">
                                    <div className="documents-grid" style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
                                        gap: '24px',
                                        padding: '10px 0'
                                    }}>
                                        <DocumentItem
                                            label="Company Logo"
                                            path={formData.company_logo}
                                            icon={<FaImage />}
                                            onFileSelect={(file) => setFormData(prev => ({ ...prev, company_logo: file }))}
                                        />
                                        <DocumentItem
                                            label="Business Card"
                                            path={formData.business_card}
                                            icon={<FaIdCard />}
                                            onFileSelect={(file) => setFormData(prev => ({ ...prev, business_card: file }))}
                                        />
                                        <DocumentItem
                                            label="License Copy"
                                            path={formData.license_copy}
                                            icon={<FaFileAlt />}
                                            onFileSelect={(file) => setFormData(prev => ({ ...prev, license_copy: file }))}
                                        />
                                        <DocumentItem
                                            label="Owner Photo"
                                            path={formData.owner_photo}
                                            icon={<FaUser />}
                                            onFileSelect={(file) => setFormData(prev => ({ ...prev, owner_photo: file }))}
                                        />
                                        <DocumentItem
                                            label="Office Building"
                                            path={formData.office_building_photo}
                                            icon={<FaBuilding />}
                                            onFileSelect={(file) => setFormData(prev => ({ ...prev, office_building_photo: file }))}
                                        />
                                    </div>
                                    <div className="mt-4 p-3 rounded" style={{ background: '#ECEFF1', borderLeft: '4px solid #455A64' }}>
                                        <small className="text-muted" style={{ fontSize: '13px' }}>
                                            <FaInfoCircle className="me-2" />
                                            {isAdminMode
                                                ? "Admin Edit Mode: You can preview and replace any agency documents."
                                                : "You can now update your documents. Uploaded files will be reviewed by the admin."
                                            }
                                        </small>
                                    </div>
                                </SectionCard>

                                {/* ══════════ SECTION 6: Account Security ══════════ */}
                                <SectionCard title="Account Security" icon={<FaLock />} color="#37474F">
                                    <Row className="g-3">
                                        <Col md={8}>
                                            <Form.Group className="agency-account-form-group">
                                                <Form.Label className="agency-account-label">Change Password</Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type={showPassword ? 'text' : 'password'}
                                                        name="password"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        className="agency-account-input pe-5"
                                                        placeholder="Leave blank to keep current password"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        style={{
                                                            position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                                                            background: 'none', border: 'none', cursor: 'pointer', color: '#6c757d'
                                                        }}
                                                    >
                                                        {showPassword ? <BsEyeSlash size={18} /> : <BsEye size={18} />}
                                                    </button>
                                                </div>
                                                <small className="text-muted" style={{ fontSize: 11 }}>Leave blank to keep your current password</small>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </SectionCard>

                                {/* ══════════ Save Button ══════════ */}
                                <div className="text-center" style={{ marginTop: 32 }}>
                                    <button
                                        className="agency-account-submit-btn"
                                        onClick={handleUpdate}
                                        disabled={isUpdating}
                                        style={{
                                            background: isAdminMode
                                                ? 'linear-gradient(135deg,#1565C0,#283593)'
                                                : 'linear-gradient(135deg,#1B5E20,#2E7D32)',
                                            color: '#fff', border: 'none', borderRadius: 8,
                                            padding: '12px 48px', fontWeight: 700, fontSize: 15,
                                            cursor: isUpdating ? 'not-allowed' : 'pointer',
                                            boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                                            transition: 'all 0.2s', letterSpacing: 0.5
                                        }}
                                    >
                                        {isUpdating
                                            ? <><span className="spinner-border spinner-border-sm me-2" />Saving...</>
                                            : isAdminMode
                                                ? <><FaShieldAlt style={{ marginRight: 7 }} />Save Changes (Admin)</>
                                                : <><FaSave style={{ marginRight: 7 }} />Update My Profile</>}
                                    </button>
                                </div>

                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                </Tab.Container>
            </Container>
        </>
    );
}

// ─── Section Card wrapper ─────────────────────────────────────────────────
function SectionCard({ title, icon, color, children }) {
    return (
        <div style={{
            marginBottom: 35,
            borderRadius: 12,
            border: `1px solid #e0e0e0`,
            // Removed overflow: 'hidden' to allow dropdowns to "come out"
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            position: 'relative' // Ensure alignment behavior is predictable
        }}>
            <div style={{
                background: color || '#1565C0',
                color: '#fff',
                padding: '14px 24px',
                fontWeight: 700,
                fontSize: 16,
                letterSpacing: 0.5,
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                borderRadius: '11px 11px 0 0' // Match card border radius
            }}>
                {icon && <span style={{ fontSize: 18, display: 'flex', alignItems: 'center' }}>{icon}</span>}
                {title}
            </div>
            <div style={{ padding: '28px 24px 20px', background: '#fff', borderRadius: '0 0 11px 11px' }}>
                {children}
            </div>
        </div>
    );
}

// ─── Document Item Component ──────────────────────────────────────────────
function DocumentItem({ label, path, icon, onFileSelect }) {
    const fileInputRef = useRef(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    // Initial setup and cleanup for preview
    useEffect(() => {
        if (path instanceof File) {
            const url = URL.createObjectURL(path);
            setPreviewUrl(url);
            return () => URL.revokeObjectURL(url);
        } else {
            setPreviewUrl(path ? `${BaseUrl}/${path}` : null);
        }
    }, [path]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            onFileSelect(file);
        }
    };

    return (
        <div className="document-item text-center">
            <div className="document-label mb-2" style={{ fontSize: '13px', fontWeight: 600, color: '#455A64', textTransform: 'uppercase' }}>
                {label}
            </div>
            <div
                className="document-preview-container"
                onClick={() => fileInputRef.current?.click()}
                style={{
                    height: '140px',
                    border: '2px dashed #CFD8DC',
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#F8F9FA',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    cursor: 'pointer'
                }}
                onMouseOver={(e) => e.currentTarget.style.borderColor = '#455A64'}
                onMouseOut={(e) => e.currentTarget.style.borderColor = '#CFD8DC'}
            >
                {previewUrl ? (
                    <img
                        src={previewUrl}
                        alt={label}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML += '<div class="text-muted"><FaFileAlt size={40} /><br/>File Attached</div>';
                        }}
                    />
                ) : (
                    <div className="text-muted">
                        {React.cloneElement(icon, { size: 30 })}<br />
                        <span style={{ fontSize: '11px' }}>Click to Upload</span>
                    </div>
                )}

                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    background: 'rgba(69, 90, 100, 0.8)',
                    color: '#fff',
                    fontSize: '10px',
                    padding: '4px 0',
                    opacity: 0,
                    transition: 'opacity 0.3s'
                }} className="upload-overlay">
                    CHANGE PHOTO
                </div>
                <style>{`.document-preview-container:hover .upload-overlay { opacity: 1; }`}</style>
            </div>

            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept="image/*,.pdf"
                style={{ display: 'none' }}
            />

            {previewUrl && !(path instanceof File) && (
                <a href={previewUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-secondary mt-2 w-100" style={{ fontSize: '11px' }}>
                    View Current
                </a>
            )}
            {path instanceof File && (
                <div className="mt-2 text-success" style={{ fontSize: '11px', fontWeight: 600 }}>
                    <FaCheckCircle className="me-1" /> New File Selected
                </div>
            )}
        </div>
    );
}

export default AgencyMyaccount;
